import { render, staticRenderFns } from "./DescribeDocumentModal.vue?vue&type=template&id=57f90bc1&"
import script from "./DescribeDocumentModal.vue?vue&type=script&lang=js&"
export * from "./DescribeDocumentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports